import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from '../../../../InputComponent';
import { LanguageFactory } from '../../../../../factories';
import { useLanguage } from '../../../../../store/languageContext';
import SearchDebounceBar from '../../../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../../../factories/propertySearchs';
import { Button, Card, Table } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { sortHelper } from '../../../../../helpers/misc/sortHelper'

interface PropsType {
    changeTab: void | any,
    setPetsDetails: void | any,
    isEditable: void | any,
    detailData: any
}


const Pets = (props: PropsType) => {

    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState<Array<any>>([]);
    const [total, setTotal] = useState(dataSource?.length || 0)
    const [data, setData] = useState<any[]>([]);
    
   
//applicalbeDaysWeek
    const columns = [
        {
            title: '',
            key: 'index',
            render: (text: string, record: [], index: number) => index += 1,
            width: '40px'
        },
        {
            title: 'Policy Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
            showSorterTooltip: false
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            sorter: (a: [], b: []) => sortHelper(a, b, 'type'),
            showSorterTooltip: false
        },
        {
            title: 'Size',
            dataIndex: 'size',
            key: 'size',
            sorter: (a: [], b: []) => sortHelper(a, b, 'size'),
            showSorterTooltip: false
        },
        {
            title: 'Unit of Measure',
            dataIndex: 'uom',
            key: 'uom',
            sorter: (a: [], b: []) => sortHelper(a, b, 'uom'),
            showSorterTooltip: false
        },
        {
            title: 'Maximum Number of Pets',
            dataIndex: 'max',
            key: 'max',
            sorter: (a: [], b: []) => sortHelper(a, b, 'max'),
            showSorterTooltip: false
        },
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }


    const getData = async ( ) => {
        setDataSource(props?.detailData?.policies?.petpolicy|| []);
        setData(props?.detailData?.policies?.petpolicy|| [])
    }

    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                if (typeof item[col.dataIndex] === 'string') {
                    itemData[col['dataIndex']] = item[col.dataIndex].toLowerCase();
                }
            })

            return JSON.stringify(itemData)
                .indexOf(query.toLocaleLowerCase()) > -1;

        })

        setDataSource(filterData);
    }
    useEffect(() => {
        getData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])

    useEffect(() => {
        setTotal(dataSource.length)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [dataSource])
    
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])
    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }}>
                <Grid container spacing={0} className="containerSpacing py-0">
                    <Grid item xs={12} className="p-0">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 'bold', fontSize: 14, color: '#333' }}>Pets</div>
                            <div><Button className="db-add-btn" onClick={() => { props.isEditable();props.changeTab('PetsAdd')}}>Add</Button></div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <ImputComponent
                            className = 'SearchBar'
                            //label={lang.translate(language, 'search')}
                            label='Search'
                            labelShrink = {true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder={lang.translate(language, 'policies_pets_search')}
                            endAdornment={<SearchIcon style={{color: '#9a9a9a'}}/>}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="p-0">
                        <Table
                            columns={columns}
                            dataSource={
                                dataSource
                            }
                            pagination={{
                                size: "small",
                                total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                defaultPageSize: 10,
                                defaultCurrent: 1,
                                onChange: (page, pageSize) => {
                                    console.log(page + '===' + pageSize)
                                }
                            }}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        props.setPetsDetails(record)
                                        props.changeTab('PetsDetails')
                                    },
                                };
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>
        </PageContainer>
    )
}

export default Pets;
